import { CustomCurrencySymbolsInterface } from './../interfaces/custom-currency-symbols.interface';

import { Inject, Injectable } from '@angular/core';
import {
  TechLibPipeConfig,
  TECH_LIB_PIPE_CONFIG,
} from '../tech-lib-pipe.module';

enum formatPositionEnum {
  digitGroupSeparator = 0,
  decimalCharacter = 1,
  decimalCharacterAlternative = 2,
  decimalPlaces = 3,

  currencySymbol = 4,
  currencySymbolPlacement = 5,
  currencyPosition = 6,
  currencySymbolPosition = 7,

  roundingMethod = 8,
  minimumValue = 9,
  tenThousand = 10,

  negativeSymbol = 11,
  positiveSymbol = 12,

  plusMinusPosition = 13,
  percentSymbol = 14,

  dateFormat = 15,
}

@Injectable({
  providedIn: 'root',
})
export class FormatsService {
  private formats = [];

  constructor(@Inject(TECH_LIB_PIPE_CONFIG) private config: TechLibPipeConfig) {
    this.formats = JSON.parse(config.formatsTech);
  }

  get locale(): string {
    return this.config.language;
  }

  set locale(locale: string) {
    this.config.language = locale;
  }

  get digitGroupSeparator(): any {
    return this.config.groupSeparator
      ? this.config.groupSeparator
      : this.formats[formatPositionEnum.digitGroupSeparator];
  }

  get decimalCharacter(): any {
    return this.config.decimalSeparator
      ? this.config.decimalSeparator
      : this.formats[formatPositionEnum.decimalCharacter];
  }

  get decimalCharacterAlternative(): any {
    return this.config.decimalSeparator
      ? this.config.decimalSeparator
      : this.formats[formatPositionEnum.decimalCharacterAlternative];
  }

  get decimalPlaces(): any {
    return this.config.numberOfDecimals
      ? this.config.numberOfDecimals
      : this.formats[formatPositionEnum.decimalPlaces];
  }

  /*
  get currencySymbol(): any {
    return this.config.baseCurrenncy
      ? this.config.baseCurrenncy
      : this.formats[formatPositionEnum.currencySymbol];
  }*/

  get currencySymbolPlacement(): any {
    return this.formats[formatPositionEnum.currencySymbolPlacement];
  }

  get currencyPosition(): any {
    return this.formats[formatPositionEnum.currencyPosition];
  }

  get currencySymbolPosition(): any {
    return this.formats[formatPositionEnum.currencySymbolPosition];
  }

  get roundingMethod(): any {
    return this.formats[formatPositionEnum.roundingMethod];
  }

  get minimumValue(): any {
    return this.formats[formatPositionEnum.minimumValue];
  }

  get tenThousand(): any {
    return this.formats[formatPositionEnum.tenThousand];
  }

  get negativeSymbol(): any {
    return this.formats[formatPositionEnum.negativeSymbol];
  }

  get positiveSymbol(): any {
    return this.formats[formatPositionEnum.positiveSymbol];
  }

  get plusMinusPosition(): any {
    return this.formats[formatPositionEnum.plusMinusPosition];
  }

  get percentSymbol(): any {
    return this.formats[formatPositionEnum.percentSymbol];
  }

  get dateFormat(): any {
    return this.config.shortDatePattern
      ? this.config.shortDatePattern
      : this.formats[formatPositionEnum.dateFormat];
  }

  /*
  set customCurrencySymbols(data: CustomCurrencySymbolsInterface[]) {
    this.config.customCurrencySymbols = data;
  }
*/

  get customCurrencySymbols(): CustomCurrencySymbolsInterface[] {
    return this.config.customCurrencySymbols
      ? this.config.customCurrencySymbols
      : null;
  }

  get customCurrencyPosition(): string {
    return this.config.customCurrencyPosition
      ? this.config.customCurrencyPosition
      : null;
  }

  /*
  getExistCurrencySymbols(): boolean {
    if (this.config.customSymbols) return this.config.customSymbols.length > 0;
    else return false;
  }
  */

  // Para el autonumeric:

  getAutonumericFormats(numDecimals: number, isCcy: boolean) {
    return {
      digitGroupSeparator: this.digitGroupSeparator,
      decimalCharacter: this.decimalCharacter,
      decimalCharacterAlternative: this.decimalCharacterAlternative,
      decimalPlaces: numDecimals,
      // currencySymbol: isCcy ? this.currencySymbol : '',
      currencySymbolPlacement: this.currencySymbolPlacement,
      roundingMethod: this.roundingMethod,
      minimumValue: this.minimumValue,
    };
  }

  getAutonumericFormatsCcy(numDecimals: number, ccy: string) {
    return {
      digitGroupSeparator: this.digitGroupSeparator,
      decimalCharacter: this.decimalCharacter,
      decimalCharacterAlternative: this.decimalCharacterAlternative,
      decimalPlaces: numDecimals,
      currencySymbol: ccy,
      currencySymbolPlacement: this.currencySymbolPlacement,
      roundingMethod: this.roundingMethod,
      minimumValue: this.minimumValue,
    };
  }

  getAutonumericPercFormats(numDecimals: number) {
    return {
      digitGroupSeparator: this.digitGroupSeparator,
      decimalCharacter: this.decimalCharacter,
      decimalCharacterAlternative: this.decimalCharacterAlternative,
      decimalPlaces: numDecimals,
      currencySymbol: '',
      currencySymbolPlacement: this.currencySymbolPlacement,
      roundingMethod: this.roundingMethod,
      minimumValue: this.minimumValue,
      suffixText: ' %',
      wheelStep: 0.0001, // This targets the `rawValue`, not the formatted one
      rawValueDivisor: 100,
    };
  }
}
